/**
 * CertExpiryBanner — aviso de proximidade de vencimento do certificado A1.
 *
 * Emitir com certificado vencido é rejeição certa no fisco, então avisamos antes:
 * amarelo em <= 30 dias, vermelho em <= 7 dias ou já vencido. A classificação é a
 * função pura certExpiryStatus (coberta por teste); aqui é só apresentação.
 */
import { AlertTriangle, ShieldAlert } from 'lucide-react';
import { useActiveCertificate } from '@/hooks/useNfse';
import { certExpiryStatus, certExpiryNeedsAttention } from '@/lib/certExpiry';

export function CertExpiryBanner() {
  const { data: cert } = useActiveCertificate();
  const status = certExpiryStatus(cert?.not_after ?? null);
  if (!certExpiryNeedsAttention(status.level)) return null;

  const days = status.days ?? 0;
  const isRed = status.level === 'expired' || status.level === 'urgent';

  const message =
    status.level === 'expired'
      ? 'Certificado digital vencido — não é possível emitir NFS-e. Faça o upload de um certificado A1 válido.'
      : status.level === 'urgent'
        ? `Seu certificado digital vence em ${days} ${days === 1 ? 'dia' : 'dias'}. Renove agora para não interromper a emissão.`
        : `Seu certificado digital vence em ${days} dias. Programe a renovação do A1.`;

  const cls = isRed
    ? 'border-red-200 bg-red-50 text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-300'
    : 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-300';

  const Icon = isRed ? ShieldAlert : AlertTriangle;

  return (
    <div className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${cls}`} role="alert">
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <p>{message}</p>
    </div>
  );
}
